import { ActionTypes, RankingTextActionTypes } from './types';
import { QuestionsState } from '../types';

export default function reducer(state: QuestionsState, action: RankingTextActionTypes) {
  switch (action.type) {
    case ActionTypes.QUESTION_RANKING_ANSWERS_ARE_SELECTED:
      return action.payload.answers;
    default:
      return state;
  }
}
